
import { View, Utils } from '../vendor/kerneljs';
import Sticky from '../components/sticky';


const CheckoutBasketParking = View.extend({

	isOpen:false,

	events: {
		'click .js--edit-time': 'onEditTime',
		'click .js--edit-overlay-close': 'onCloseOverlay',
		'click .js--edit-overlay-submit': 'onEditTimeSubmit',
		'click .js--toggle-details': 'onToggleDetails',
		'click .js--backdrop': 'onToggleDetails'
	},

	initialize: function(){
		this.editTimeOverlay = this.find('.js--edit-overlay');

		this.wrapper = document.querySelector('.checkout-basket-wrapper');
		new Sticky( {el: this.wrapper} );
	},

	onToggleDetails:function() {
		document.querySelector('.checkout-basket').classList.toggle('is-open');
	},

	onEditTime:function() {
		Utils.showElement(this.editTimeOverlay);
	},
	onCloseOverlay:function() {
		Utils.hideElement(this.editTimeOverlay);
	},
	onEditTimeSubmit:function() {
		this.onCloseOverlay();
	},
});

(function(){
	Utils.each(Utils.find('.js--checkout-basket-parking'), function(elem) {
		new CheckoutBasketParking( {el: elem} );
	});
})();
export default CheckoutBasketParking;
